import { Range } from 'react-date-range';

import {
  FieldOptionObjV2,
  FieldOptionV2,
  MultiFieldFilterV2Props,
  SelectAllModes,
  SelectedFilterValues
} from './types';

export const isFieldDisabled = (
  field: FieldOptionV2,
  selected: SelectedFilterValues
): boolean => {
  if (typeof field.disabled === 'function') return field.disabled(selected);
  return field.disabled || false;
};

export const getFirstEnabledField = (
  fields: FieldOptionObjV2,
  selected: SelectedFilterValues = {}
): string => {
  const keys = Object.keys(fields);
  return keys.find((k) => !isFieldDisabled(fields[k], selected)) || keys[0];
};

export const buildCustomFields = (
  customFields: MultiFieldFilterV2Props['customFields'],
  activeField: string,
  dateRange: Range
) => {
  const entry = {
    key: activeField,
    value: {
      startDate: dateRange.startDate?.toISOString() || '',
      endDate: dateRange.endDate?.toISOString() || ''
    }
  };
  if (!customFields?.length) return [entry];
  const exists = customFields.some((f) => f.key === activeField);
  if (exists)
    return customFields.map((f) =>
      f.key === activeField ? { ...f, value: entry.value } : f
    );
  return [...customFields, entry];
};

export const getInitialDateRange = (
  customFields: MultiFieldFilterV2Props['customFields'],
  activeField: string
): Range => {
  const match = customFields?.find((f) => f.key === activeField);
  if (match?.value) {
    return {
      startDate: new Date(match.value.startDate),
      endDate: new Date(match.value.endDate),
      key: 'selection'
    };
  }
  return { startDate: new Date(), endDate: new Date(), key: 'selection' };
};

export const deriveSelectAllState = (fields: FieldOptionObjV2) => {
  const modes: SelectAllModes = {};
  const excluded: SelectedFilterValues = {};
  Object.values(fields).forEach((f) => {
    if (f.hasSelectAll) {
      modes[f.field] = f.isSelectAll || false;
      excluded[f.field] = f.excludedValues || [];
    }
  });
  return { modes, excluded };
};
